//
//
//
//
//
//
//

import Avatar from 'vue-avatar'

export default {
  components: {
    Avatar
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    errorImageUrl: {
      type: String,
      required: false,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    wrapperClass: {
      type: String,
      default: ''
    },
  },
  data: () => {
    return {
      'hasError': false,
    }
  },
  computed: {
    showError () {
      return this.hasError
    },
    errorImage () {
      if (this.errorImageUrl !== '') {
        return this.errorImageUrl
      }
      return this.defaultErrorImage
    },
},
  watch: {
    imageUrl: {
      immediate: true,
      handler (value, oldValue) {
        this.hasError = false
        // console.log('image changed', value, oldValue)
      }
    }
  },
  methods: {
    onError (error) {
      this.hasError = true
      console.log('could not load image due to error ', this.imageUrl, error)
    }
  }
}
